import { render, staticRenderFns } from "./w-icon.vue?vue&type=template&id=51c55dfe&scoped=true"
import script from "./w-icon.vue?vue&type=script&lang=ts"
export * from "./w-icon.vue?vue&type=script&lang=ts"
import style0 from "./w-icon.vue?vue&type=style&index=0&id=51c55dfe&prod&lang=scss"
import style1 from "./w-icon.vue?vue&type=style&index=1&id=51c55dfe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c55dfe",
  null
  
)

export default component.exports